module.exports = __webpack_public_path__ + "static/img/bg3.a29e819.png";


//////////////////
// WEBPACK FOOTER
// ./src/model/Images/bg3.png
// module id = AxTT
// module chunks = 1